// Shared Active/Inactive status filter values for property-config listing
// pages (Rate Plans DR listing, Taxes & Fees).
export const STATUS_FILTER = {
  ALL: "all",
  ACTIVE: "active",
  INACTIVE: "inactive",
};

export const STATUS_FILTER_OPTIONS = [
  { label: "Active & Inactive", value: STATUS_FILTER.ALL },
  { label: "Active", value: STATUS_FILTER.ACTIVE },
  { label: "Inactive", value: STATUS_FILTER.INACTIVE },
];
